export var allocatedAmount = function (payIn) { var _a; return ((_a = payIn.paymentPayInAllocations) === null || _a === void 0 ? void 0 : _a.reduce(function (x, y) { return x + y.amount; }, 0)) || 0; };
export var amountToBeAllocated = function (payIn) {
    return payIn.amount - allocatedAmount(payIn);
};
export var isPristine = function (payIn) {
    return amountToBeAllocated(payIn) === payIn.amount;
};
